import { Controller } from '@hotwired/stimulus';
import { extractPageProperties } from '../utils/pageProperties';

export default class extends Controller {
  connect() {
    this.pageProperties = extractPageProperties();
  }

  track({ params: { event, payload } }) {
    if (payload) {
      payload = { ...this.pageProperties, ...payload };
      window.analytics?.track(event, payload);
    } else {
      window.analytics?.track(event, this.pageProperties);
    }

    if (!event) {
      console.warn('No name for event');
    }
  }
}
